<template>
  <div class="issue-sheet"
       @scroll="handleScroll"
       :data-scroll="issueSheetScroll">
    <div class="issue-header"
         v-if="!documentView">
      <div class="back">
        <button @click="back">
          <i class="icon icon--back"></i> Back
        </button>
      </div>
      <h2>{{ currentCategory.showId }}. {{ currentCategory.titleEn }}</h2>
      <ul v-if="subCategories.length"
          class="sub-categories">
        <li v-for="subCategory in subCategories"
            :key="subCategory.id">
          <a href="#none"
             class="depth_list"
            :class="currentSubCategory.id === subCategory.id ? 'active' : ''"
            @click.prevent="onSubCategoryClick(subCategory)">
            {{ subCategory.titleEn }}
            <em v-if="categoryResultMap[subCategory.id] && Object.keys(categoryResultMap[subCategory.id]).length">
              {{ getSubCategoryCount(subCategory.id) }}
            </em>
          </a>
        </li>
      </ul>
    </div>

    <div v-if="!documentView"
         class="issue-detail"
         ref="issueDetail">
      <template v-if="subCategories.length">
        <report-issue-list-item :currentIssue="currentIssue"
                                :nodeDataMap="nodeDataMap"
                                :currentSubCategory="currentSubCategory"
                                :categoryResultMap="categoryResultMap"
                                :ruleUiType="ruleUiType"
                                :imageUrl="imageUrl"
                                @onIssueClick="onIssueClick" />
      </template>
      <div v-else class="no-by-case">
        <p>
          <i class="icon icon--empty"></i><br>
          {{ $t('report.noIssues') }}
        </p>
      </div>
    </div>

    <div v-else
         class="issue-detail"
         ref="issueDetail">
      <div v-for="currentSubCategory of subCategories"
           v-if="categoryResultMap[currentSubCategory.id] && Object.keys(categoryResultMap[currentSubCategory.id]).length"
           :key="currentSubCategory.id">
        <ul class="sub-categories">
          <li>
            <a href="#none"
               class="depth_list active">
              {{ currentSubCategory.titleEn }}
              <em>{{ getSubCategoryCount(currentSubCategory.id) }}</em>
            </a>
          </li>
        </ul>
        <report-issue-list-item :currentIssue="currentIssue"
                                :nodeDataMap="nodeDataMap"
                                :currentSubCategory="currentSubCategory"
                                :categoryResultMap="categoryResultMap"
                                :ruleUiType="ruleUiType"
                                :imageUrl="imageUrl" />
      </div>
    </div>
  </div>
</template>

<script>
import { apiImageUrl } from '@/lib/http-client'
import ruleUiType from '@/data/rule-ui-type'

import ReportIssueListItem from './ReportIssueListItem'

export default {
  name: 'ReportIssueList',
  components: {
    ReportIssueListItem
  },
  props: [
    'currentCategory',
    'issueData',
    'report',
    'categoryResultMap',
    'currentIssue',
    'nodeDataMap',
    'documentView'
  ],
  data () {
    return {
      ruleUiType: null,
      currentSubCategory: {},
      issueSheetScroll: 0
    }
  },
  computed: {
    imageUrl () {
      const result = {}
      for (let [key, url] of Object.entries(this.report.imageUrl)) {
        result[key] = apiImageUrl(url)
      }
      return result
    },
    scoreMap () {
      return this.issueData.scoreMap
    },
    subCategories () {
      return this.currentCategory.SwasSubCategories
    }
  },
  watch: {
    currentCategory () {
      if (this.$refs.issueDetail) {
        this.$refs.issueDetail.scrollTop = 0
      }

      this.initSubCategory()
    }
  },
  created () {
    this.ruleUiType = ruleUiType
    this.initSubCategory()
  },
  methods: {
    handleScroll (e) {
      if (this.issueSheetScroll === 0 && e.target.scrollTop >= 120) {
        this.issueSheetScroll = 1
      } else if (this.issueSheetScroll === 1 && e.target.scrollTop <= 100) {
        this.issueSheetScroll = 0
      }
    },
    getSubCategoryCount (subCategoryId) {
      const value = Object.values(this.categoryResultMap[subCategoryId]).reduce((acc, cur) => {
        return acc + cur.length
      }, 0)
      return value
    },
    back () {
      this.$emit('onViewTypeChange', 'summary')
    },
    initSubCategory () {
      this.itemNo = 1
      const subCategoryIds = Object.keys(this.subCategories)

      if (subCategoryIds.length) {
        this.currentSubCategory = this.subCategories[subCategoryIds[0]]
      } else {
        this.currentSubCategory = {}
      }
    },
    onIssueClick (issue, arrayIdx) {
      this.itemNo = 1
      if (arrayIdx !== null || arrayIdx !== undefined) {
        if (issue && issue.preview && issue.preview.nodeData && issue.preview.nodeData[arrayIdx]) {
          issue = {
            ...issue,
            ...issue.preview.nodeData[arrayIdx],
            arrayIdx
          }
        } else {
          issue = {
            ...issue,
            arrayIdx
          }
        }
      }
      this.$emit('onIssueClick', issue)
    },
    onSubCategoryClick (item) {
      if (this.currentSubCategory === item) {
        return
      }
      this.onIssueClick(null)
      this.$refs.issueDetail.scrollTop = 0
      this.currentSubCategory = item
    }
  }
}

</script>

<style lang="scss" scoped>
.issue-sheet {
  border-radius: 10px;
  box-shadow: 0 23px 15px -12px rgba(0, 0, 0, 0.08), 0 0 0 1px rgba(0, 0, 0, 0.08);
  background-color: #ffffff;
  height: 100%;
  overflow: auto;
  position: relative;

  .issue-header {
    margin: 0 5px 4px;
    padding-bottom: 1px;
    padding-top: 5px;
    background: #ffffff;
    position: sticky;
    top: 0;
    left: 0;
    width: calc(100% - 10px);
    z-index: 9;
    transition: padding-bottom 0.3s ease;

    &:after {
      content: "";
      position: absolute;
      bottom: 0;
      left: -5px;
      width: calc(100% + 10px);
      height: 0;
      background-image: linear-gradient(to bottom, rgba(0, 0, 0, 0.12), rgba(0, 0, 0, 0));
      transition: height 0.3s ease, bottom 0.3s ease;
    }

    .back {
      button {
        padding: 5px 10px 5px 5px;
        line-height: 20px;
        font-size: 14px;
        font-weight: 600;
        color: #444444;
        border-radius: 6px;
        box-shadow: 0 2px 2px -2px rgba(0, 0, 0, 0.2);
        border: solid 1px rgba(0, 0, 0, 0.13);
        background-color: #ffffff;
        width: 75px;
        height: 32px;
        overflow: hidden;
        white-space: nowrap;
        transition: width 0.3s ease;

        .icon {
          margin-right: 2px;
        }
      }
    }

    h2 {
      position: absolute;
      top: 37px;
      left: 0;
      padding: 10px 15px;
      font-size: 32px;
      color: #222222;
      font-weight: 600;
      transition: top 0.3s ease,
                  left 0.3s ease,
                  font-size 0.3s ease;
    }
  }

  .issue-detail {
    margin: 10px 20px 20px 20px;
  }

  .sub-categories {
    border-radius: 6px;
    background-color: #151515;
    margin: 75px 15px 17px;
    transition: margin 0.3s ease;
    -webkit-print-color-adjust: exact !important;
    color-adjust: exact !important;

    li {
      display: inline-block;

      .depth_list {
        position: relative;
        display: block;
        color: #ffffff;
        font-size: 15px;
        font-weight: 500;
        padding: 12px 15px;
        transition: padding 0.3s ease;

        em {
          -webkit-print-color-adjust: exact !important;
          color-adjust: exact !important;
          background: #ec0047;
          color: #eeeeee;
          padding: 2px 8px 2px 7px;
          margin: -2px 0;
          border-radius: 30px;
          margin-left: 2px;
          font-size: 12px;
          display: inline-block;
          vertical-align: middle;
          transform: translateY(-1px);
          min-width: 7px;
          text-align: center;
        }

        &.active {
          background: #ec0047;

          em {
            background: #ffffff;
            color: #333333;
          }

          &::before {
            content: "";
            display: block;
            position: absolute;
            bottom: -6px;
            left: 50%;
            width: 0;
            height: 0;
            transform: translateX(-50%);
            border-left: 6px solid transparent;
            border-right: 6px solid transparent;
            border-top: 6px solid #ec0047;
            transition: bottom 0.3s ease;
          }
        }
      }

      &:first-child {
        .depth_list {
          border-radius: 6px 0 0 6px;
        }
      }
    }
  }

  &[data-scroll='1'] {
    .issue-header {
      &:after {
        bottom: -14px;
        height: 14px;
      }

      .back {
        button {
          width: 32px;
        }
      }

      h2 {
        top: -1px;
        left: 35px;
        font-size: 17px;
      }

      ul {
        margin: 20px 15px 62px;

        li {
          .depth_list {
            padding: 7px 15px 8px;

            &.active {
              &::before {
                bottom: 0;
              }
            }
          }
        }
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/valid-member/report/ReportIssueList.vue